import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import BaseUserBooksView from 'rebook/apps/users/views/BaseUserBooksView';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


class UserWishlistBooksView extends BaseUserBooksView {
  constructor(props) {
    super(props);
    this.title = 'Хочу прочитать в моих книгах в электронной библиотеке MyBook';
    this.readingList = 1;
    this.breadcrumbs = [
      { text: 'Мои книги', url: `/profile/${this.props.match.params.userId}/` },
      { text: this.getInitialHeaderTitle(), url: get(this, 'props.location', '') },
    ];
  }

  getInitialHeaderTitle() {
    return 'Хочу прочитать';
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(UserWishlistBooksView);
